import type { ModelChangeApprovalResult } from '@ayumia/contracts';
import type { ApiClient } from '../../api/client';
import type { ApprovalAnswer } from './editor-types';

/**
 * Le serveur dit si la personne connectée peut approuver une proposition du Studio (`GetModelChangeApproval`,
 * contrat `model-change-approval-result` 1.0.0) : même règle qu'`ApproveModelChange` et même politique. Une
 * erreur de lecture vaut « non » (deny par défaut) ; la commande reste juge à l'exécution.
 */
/** Avant de proposer : la personne publierait-elle seule un tel changement (GetModelChangeApproval 1.1.0) ? */
export async function publishAccess(client: ApiClient, targetKind: string, structural: boolean): Promise<ApprovalAnswer> {
  try {
    const result = (await client.query<ModelChangeApprovalResult>('GetModelChangeApproval', { target_kind: targetKind, structural: String(structural) })).data;
    return result.can_approve ? { can: true } : { can: false, ...(result.message === undefined ? {} : { message: result.message }) };
  } catch {
    return { can: false };
  }
}

export async function modelChangeApproval(client: ApiClient, modelChangeId: string): Promise<ApprovalAnswer> {
  try {
    const result = (await client.query<ModelChangeApprovalResult>('GetModelChangeApproval', { model_change_id: modelChangeId })).data;
    return result.can_approve ? { can: true } : { can: false, ...(result.message === undefined ? {} : { message: result.message }) };
  } catch {
    return { can: false, message: 'Impossible de savoir si vous pouvez approuver : réessayez plus tard.' };
  }
}
